import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../../keycloack/auth.service';
import { ThemeService } from '../../../services/theme.service';
import { ROLES } from '../../../utils/constants';

interface NavItem {
  label: string;
  icon: string;
  route: string;
  exact: boolean;
  roles: ROLES[];
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Home', icon: 'dashboard', route: '/avvisi', exact: true, roles: [ROLES.admin, ROLES.gestore, ROLES.esperto] },
  { label: 'I miei bandi', icon: 'description', route: '/avvisi/lista', exact: false, roles: [ROLES.admin, ROLES.gestore, ROLES.esperto] },
  { label: 'Configurazione bandi', icon: 'settings', route: '/admin/avvisi', exact: false, roles: [ROLES.admin] },
  { label: 'Assistenza Progetti', icon: 'confirmation_number', route: '/ticketing', exact: true, roles: [ROLES.admin, ROLES.supporto] },
];

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css',
})
export class TopBarComponent {
  readonly navItems = NAV_ITEMS;

  constructor(
    private authService: AuthService,
    public themeService: ThemeService
  ) {}

  get fullname(): string | null {
    return this.authService.getFullname();
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  isNavItemVisible(item: NavItem): boolean {
    const roles = this.authService.getRoles();
    return item.roles.some((r) => roles.includes(r));
  }

  logout(): void {
    this.authService.logout();
  }

  onToggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
